export const localeMockResponse = [
    {
        "locale": "en_US",
        "title": "English",
        "store": "belgium_english",
        "is_default": true
    },
    {
        "locale": "it_IT",
        "title": "Italian",
        "store": "default"
    },
    {
        "locale": "de_DE",
        "title": "German",
        "store": "austria_german"
    },
    {
        "locale": "uk_UA",
        "title": "Ukrainian",
        "store": "ukraine_ukrainian"
    },
    {
        "locale": "tr_TR",
        "title": "Turkish",
        "store": "turkey_turkish"
    },
    {
        "locale": "pt_BR",
        "title": "Portuguese",
        "store": "angola_portuguese"
    },
    {
        "locale": "ru_RU",
        "title": "Russian",
        "store": "azerbaijan_russian"
    },
    {
        "locale": "fr_FR",
        "title": "French",
        "store": "france_french"
    },
    {
        "locale": "ja_JP",
        "title": "Japanese",
        "store": "japan_japanese"
    },
    {
        "locale": "es_ES",
        "title": "Spanish",
        "store": "argentina_spanish"
    },
    {
        "locale": "zh_Hant_TW",
        "title": "Chinese",
        "store": "taiwan_traditional_chinese_tw"
    },
    {
        "locale": "id_ID",
        "title": "Indonesian",
        "store": "indonesia_bahasa"
    },
    {
        "locale": "zh_Hans_CN",
        "title": "Chinese",
        "store": "China_traditional_chinese_tw"
    },
    {
        "locale": "he_IL",
        "title": "Hebrew",
        "store": "israel_hebrew"
    }
]